export default __webpack_public_path__ + "static/media/1-10.addf9391.png";